import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { TwoLineGridCell } from "fe-shared-transactions/src/components/TransactionsDataGrid/renderers";

import { GridInvoice } from "fe-shared-transactions/src/types";

interface Props extends ICellRendererParams {
  data: GridInvoice;
}

const ParticipantRenderer = ({ data }: Props) => {
  const { company } = data;

  return (
    <TwoLineGridCell
      firstLineData={company?.displayName}
      secondLineData={company?.regNumber}
    />
  );
};

export default ParticipantRenderer;
